<template>
  <div class="payment">
    <!-- Summary -->
    <div class="summary">
      <div class="product-selection">
        <span>${{ donation.amount }}</span> /
        <span>{{ getFrequency(donation.type) }}</span>
      </div>
      <div class="secure">
        <img src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/secure-icon.svg" />
        <div class="text">
          <p>Secure</p>
          <p>payment</p>
        </div>
      </div>
    </div>

    <hr />

    <!-- Checkout -->
    <h2>Enter Payment Details</h2>
    <component
      :is="paymentform"
      @success="processSuccess"
      @retry="retryPayment"
      ref="checkout"
    ></component>
  </div>
</template>

<script>
import CreditCard from "./CreditCard.vue";
import DirectDebit from "./DirectDebit.vue";

import { mapState } from "vuex";
import gtm from "./../../utils/gtm";
import { getNameByDonationType, getNameByPaymentType, getParameterByName } from "./../../helpers";

export default {
  name: "Payment",
  components: {
    CreditCard,
    DirectDebit,
  },

  props: {
    thankYouUrl: {
      type: String,
      default: null,
    },
    useProductThankYouUrl: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    paymentform() {
      if (
        this.$store.state.donation.donation.payementType ==
        "wwf_purchasetokenise"
      ) {
        return "CreditCard";
      } else {
        return "DirectDebit";
      }
    },
    ...mapState({
      donation: (state) => state.donation.donation,
      product: (state) => state.product.product,
    }),
  },
  methods: {
    getFrequency(donationType) {
      switch (donationType) {
        case "Regular":
          return "monthly";
        default:
        case "Single":
          return "one-off";
      }
    },
    async processSuccess(data) {
      try {
        // Make the payment
        if (this.donation.payementType === "wwf_purchasetokenise") {
          // CREDIT CARD
          await this.$store.dispatch("paymentCreditCard", {
            token: data.token,
            cardHolderName: data.cardHolderName,
          });
        } else {
          // DIRECT DEBIT
          await this.$store.dispatch("paymentDirectDebit", {
            accno: data.accno,
            accrouting: data.accrouting,
            acctitle: data.acctitle,
          });
        }

        console.log("Payment success");
        this.$store.commit("setTransactionId", this.donation.key);

        this.$store.dispatch('logFormPaySuccess', this.donation.key);

        this.thanksUser();

        this.$refs.checkout.reset();

        // Make sure the data about the supporter has been transfered to the main
        // to be displayed on the thank you popup or other before reseting the data.
        setTimeout(() => {
          this.$emit("reset");
        }, 1000);
      } catch (error) {
        console.error("Server Error", error);
        const isRestrictedIP = error.status == 403 && error.body;
        this.$store.dispatch("logFormPayFail", "Server Error");
        this.$refs.checkout.reset(
          isRestrictedIP ?
          error.body.message :
          "Oops something happened and we were not able to process your payment, please try again."
        );
      }
    },
    thanksUser() {
      // Check query params for step up override
      const stepupId = getParameterByName("stepup");
      if (stepupId) {
        this.$store
          .dispatch("getContentMessageById", stepupId)
          .then((response) => {
            const title = response.description;
            const content = response.content;
            const details = { ...this.donation };

            this.$store.commit("setPopupContent", {
              component: "step-up",
              componentparams: {
                id: stepupId,
                title,
                content,
                details
              },
            });
            
            this.$store.commit("openStepUpPopup", true);

            // Log to amplitude
            this.$store.dispatch("logStepUp", stepupId);
          })
          .catch((err) => {
            console.error(err);
          });

        this.sendToGTM();
        return;
      }
      
      // If no step up override, continue with regular thank you flow
      const donateThankYouUrl = this.donation.thankYouUrl;
      if (
        (this.useProductThankYouUrl && donateThankYouUrl) ||
        this.thankYouUrl
      ) {
        let query = `firstname=${this.donation.firstname}`;
        query += `&lastname=${this.donation.lastname}`;
        query += `&frequency=${this.donation.type}`;
        query += `&amount=${this.donation.amount}`;
        query += `&source=${document.URL}`;

        let params = "?q=" + window.btoa(query);
        const baseUrl =
          this.useProductThankYouUrl && donateThankYouUrl
            ? donateThankYouUrl
            : this.thankYouUrl;
        const url = baseUrl + params;

        this.$store.dispatch("logDonationComplete");

        // Send data to Google Tag Manager
        const callback = () => {
          setTimeout(() => {
            window.open(url, "_self");
          }, 1000);
        };
        this.sendToGTM(callback);

      } else {
        this.$store.dispatch("logDonationComplete");
        this.$store.commit("openDonationPopup", true);
      }
    },
    retryPayment: function () {
      this.$store
        .dispatch("retryDonation")
        .then((response) => {
          this.$refs.checkout.reset();
        })
        .catch((error) => {
          console.error("Retry donation error", error);
        });
    },
    sendToGTM(callback) {
      gtm.pushPurchase(
        this.donation.transactionid,
        this.product.productname,
        this.product.id,
        this.product.producttype,
        getNameByDonationType(this.donation.type),
        this.donation.amount,
        this.donation.billing.postcode,
        getNameByPaymentType(this.donation.payementType),
        callback
      );
    }
  },
};
</script>

<style scoped>
.summary {
  display: flex;
  justify-content: stretch;
}

.product-selection {
  flex: 1;
  color: var(--wwfBlue);
  font-size: 35px;
  font-family: "WWFRegular", sans-serif;
}
</style>


// WEBPACK FOOTER //
// Payment.vue?0ff1ef6b